import { FormEvent, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function Login({ onLogin }: { onLogin: () => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      await api.login(username, password);
      onLogin();
      nav('/');
    } catch (e: any) {
      setErr('Identifiants invalides');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-wrap">
        <div className="login-brand">
          <div className="login-brand-tile">S</div>
          <div className="login-brand-name">STM <span>Partners</span></div>
        </div>
        <form className="login-card" onSubmit={submit}>
          <h1>Bon retour</h1>
          <p className="login-sub">Connectez-vous à votre cockpit Odoo.</p>
          <label className="login-label">Nom d'utilisateur</label>
          <input autoFocus placeholder="Nom d'utilisateur" value={username} onChange={(e) => setUsername(e.target.value)} />
          <label className="login-label">Mot de passe</label>
          <input type="password" placeholder="Mot de passe" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button disabled={loading}>{loading ? '…' : 'Se connecter'}</button>
          {err && <div className="err">{err}</div>}
        </form>
      </div>
    </div>
  );
}
